import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { QuizTypes } from '@app/infrastructure/models/quiz-block';

@Component({
  selector: 'app-quiz-type',
  templateUrl: './quiz-type.component.html',
  styleUrls: ['./quiz-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizTypeComponent {
  @Input() FormGroup = new UntypedFormGroup({});
  @Input() qType: QuizTypes;
  @Output() emitQuizTypeSelected: EventEmitter<QuizTypes> = new EventEmitter();

  public QTYPE = QuizTypes;

  readonly ctrlName = 'firstCtrl';
  quizTypeFormGroup: UntypedFormGroup;

  public get stepForm() {
    return this.quizTypeFormGroup;
  }

  updateType(q: QuizTypes) {
    this.emitQuizTypeSelected.emit(q);
  }

  selectBooleanChoice(event: any) {
    this.updateType(QuizTypes.BOOLEANCHOICE);
  }

  selectMultipleChoice(event: any) {
    this.updateType(QuizTypes.MULTIPLECHOICE);
  }

  selectFreeText(event: any) {
    this.updateType(QuizTypes.FREEANSWER);
  }
}
